import { RichTextProps } from '@src/quince-components/src'

import safeParse from '../utils/safeParse'

import ContentfulRichText from './contentful/ContentfulRichText'

import type { Document } from '@contentful/rich-text-types'

export interface IRichTextReference {
  baseDynamicValueClasses: string[] | null
  content: {
    raw: string
  }
  contentful_id: string
}

interface IRichText {
  readonly raw: Document
  readonly references?: IRichTextReference[]
  readonly id?: string
  readonly commonClassNames?: string[]
  readonly desktopClassNames?: string[]
  readonly mobileClassNames?: string[]
  readonly dynamicValueClassesMobile?: string[]
  readonly baseDynamicValueClasses?: string[]
}

export default class RichText implements IRichText {
  readonly raw: Document
  readonly references?: IRichTextReference[]
  readonly id: string
  readonly commonClassNames: string[]
  readonly desktopClassNames: string[]
  readonly mobileClassNames: string[]
  readonly dynamicValueClassesMobile: string[]
  readonly baseDynamicValueClasses: string[]

  constructor({
    raw,
    references,
    id = '',
    mobileClassNames = [],
    desktopClassNames = [],
    commonClassNames = [],
    dynamicValueClassesMobile = [],
    baseDynamicValueClasses = [],
  }: IRichText) {
    this.id = id
    this.references = references
    this.raw = raw
    this.mobileClassNames = mobileClassNames
    this.desktopClassNames = desktopClassNames
    this.commonClassNames = commonClassNames
    this.dynamicValueClassesMobile = dynamicValueClassesMobile
    this.baseDynamicValueClasses = baseDynamicValueClasses
    return {
      ...this,
    }
  }

  static makeRichTextProps(richText?: RichText | null): RichTextProps | undefined {
    if (!richText) return undefined
    return {
      content: richText.raw,
      references: richText.references ?? [],
      mobileClassNames: richText.mobileClassNames,
      desktopClassNames: richText.desktopClassNames,
      commonClassNames: richText.commonClassNames,
      baseDynamicValueClasses: richText.baseDynamicValueClasses,
      dynamicValueClassesMobile: richText.dynamicValueClassesMobile,
    }
  }

  static fromContentful(contentfulRichText: ContentfulRichText) {
    return new RichText({
      raw:
        'raw' in contentfulRichText.content
          ? safeParse(contentfulRichText.content.raw, {} as Document)
          : contentfulRichText.content,
      references: 'references' in contentfulRichText.content ? contentfulRichText.content.references : [],
      mobileClassNames: contentfulRichText.mobileClassNames || [],
      desktopClassNames: contentfulRichText.desktopClassNames || [],
      commonClassNames: contentfulRichText.commonClassNames || [],
      baseDynamicValueClasses: contentfulRichText.baseDynamicValueClasses || [],
      dynamicValueClassesMobile: contentfulRichText.dynamicValueClassesMobile || [],
      id: contentfulRichText.id,
    })
  }
}
